import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, ButtonCore } from '@saviynt/design-system';
import DropDownMenu from '../DropDownMenu/DropDownMenu';
import MenuItems from './MenuItems/MenuItems';
import UserDetails from './UserDetails/UserDetails';
import useDisplayName from '../../utils/useDisplayName';

import './Profile.css';

const useStyles = makeStyles(() => ({
  profileIcon: {
    padding: 0,
    outline: (open) => (open ? '2px solid #3751FF' : '0'),
    /* TODO: Remove !important if Metronic from bootstrap is removed */
    borderRadius: '4rem !important',
    border: 0,
    '&:focus': { outlineOffset: '.125rem' },
  },
}));

const Profile = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const intl = useIntl();

  const classes = useStyles(anchorEl || false);

  const { profileImage } = useSelector((state) => state.profile);
  const displayName = useDisplayName();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const profileLabel = intl.formatMessage({
    id: 'gen2.profileMenu.ariaLabel.profile',
  });

  // Include displayName for better screen reader announcement
  const fullProfileLabel = displayName ? `${displayName}, ${profileLabel}` : profileLabel;

  return (
    <>
      <ButtonCore
        ariaLabel={fullProfileLabel}
        ariaHaspopup="true"
        ariaExpanded={Boolean(anchorEl)}
        onClick={handleClick}
        className={classes.profileIcon}
        dataTestId="profile"
      >
        <span aria-hidden="true">
          <Avatar size="medium" className="Profile-avatar" src={profileImage || null} alt="">
            {displayName}
          </Avatar>
        </span>
      </ButtonCore>
      <DropDownMenu anchorEl="body" open={Boolean(anchorEl)} onClose={handleClose}>
        <UserDetails />
        <MenuItems />
      </DropDownMenu>
    </>
  );
};

export default Profile;
